import "normalize.css";
import "vant/lib/index.css";
import "@/assets/css/style.scss";
import { setHtmlFontSize } from "@/utils/adaptation.js";
// import { setHeartbeat } from "@/utils/aLiLogTracking.js";

setHtmlFontSize();
// setHeartbeat(5);
